<template>
  <div class="header">
    <div class="main">
      <!-- <a class="logo" href="/index" title="黄河云缆">黄河云缆</a> -->
      <a class="logo-img" href="/index" title="黄河云缆"
        ><img :src="require('@/assets/huatailogo.png')" alt="" />黄河云缆</a
      >

      <div class="nav">
        <a class="nav-this" href="/index">
          <i class="iconfont icon-wenda"></i>问答
        </a>
        <!-- <a href="/static/index.html" target="_blank">
          <i class="iconfont icon-ui"></i>框架
        </a> -->
      </div>
      <div v-if="checkLogin()" class="nav-user">
        <div id="view">
          <!-- 成功登录，加载用户信息 -->
          <!-- <a class="avatar" :href="'/user/index?uid=' + user.loginState.id"> -->
          <a class="avatar">
            <img
              :src="'/static/fly/images/avatar/' + user.loginState.pic"
              alt=""
            />
            <cite>{{ user.loginState.name }}</cite>
            <i v-if="user.loginState.rmb > 0">Vip{{ user.loginState.rmb }}</i>
          </a>

          <div class="nav">
            <!-- <a href="/user/message"
              ><i class="iconfont icon-qq" style="top: 0; font-size: 22px"></i
              >消息</a
            > -->
            <a href="#" @click="logout"
              ><i
                class="iconfont icon-tuichu"
                style="top: 0; font-size: 22px"
              ></i
              >退了</a
            >
          </div>
        </div>
      </div>

      <div v-else class="nav-user">
        <div id="view">
          <!-- 未登入状态 -->
          <a class="unlogin" href="/login">
            <i class="iconfont icon-touxiang"></i>
          </a>
          <span>
            <a @click="handleLogin">登入</a>
            <!-- <a href="/user/reg">注册</a> -->
          </span>
          <!-- <p class="out-login">
            <a
              href=""
              onclick="layer.msg('正在通过QQ登入', {icon:16, shade: 0.1, time:0})"
              class="iconfont icon-qq"
              title="QQ登入"
            ></a>
            <a
              href=""
              onclick="layer.msg('正在通过微博登入', {icon:16, shade: 0.1, time:0})"
              class="iconfont icon-weibo"
              title="微博登入"
            ></a>
          </p> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data: function () {
    return {};
  },
  methods: {
    handleLogin() {
      let backurl = window.location.href;
      console.log(backurl);
      window.location.href = `https://hmlogin.huangheyunlan.com/?callUrl=${backurl}`;
    },
    logout() {
      this.$store.dispatch("logout").then(() => {
        location.reload(); // 为了重新实例化vue-router对象 避免bug
      });
    },
    checkLogin() {
      //console.log(JSON.stringify(this.user))
      return this.user.loginState != null;
    },
  },
  computed: {
    ...mapGetters(["user"]),
  },
};
</script>
<style scoped>
.logo-img {
  color: #fff;
  position: absolute;
  left: 20px;
  top: 16px;
  font-size: 16px;
}
img {
  width: 40px;
  margin-right: 10px;
}
</style>


// WEBPACK FOOTER //
// src/views/layout/header.vue